<template>
  <div class="performanceCheck">
    <van-tabs v-model="active" type="card" sticky color="#45B9BC" title-inactive-color="#999" :line-height="0">
      <van-tab title="当日">
        <div class="endTime">数据截止时间：{{time}}</div>
        <div class="performance__total">
          <ul>
            <li><div>销售额(元)</div><p class="col_45B9BC">{{dayList.sale_price_total?dayList.sale_price_total:0}}</p></li>
            <li><div>订单量(个)</div><p class="col_45B9BC">{{dayList.sale_total?dayList.sale_total:0}}</p></li>
            <li><div>成交率(%)</div><p class="col_45B9BC">{{dayList.turnover_rate?dayList.turnover_rate:0}}</p></li>
          </ul>
        </div>
        <table class="performance__table" cellspacing="0">
          <tr><th>服务项目</th><th>价格</th><th>状态</th></tr>
          <tr v-for="(proItem,proIndex) in dayList.list" :key="proIndex">
            <td>{{proItem.servicetitle}}</td><td>{{proItem.price}}</td>
            <td v-if="proItem.status=='3'" class="col_45B9BC">成交</td>
            <td v-else>未成交</td>
          </tr>
        </table>
      </van-tab>
      <van-tab title="当月">
        <div class="endTime">数据截止时间：{{time}}</div>
        <div class="performance__total">
          <ul>
            <li><div>销售额 (元)</div><p class="col_45B9BC">{{monthList.sale_price_total?monthList.sale_price_total:0}}</p></li>
            <li><div>订单量 (个)</div><p class="col_45B9BC">{{monthList.sale_total?monthList.sale_total:0}}</p></li>
            <li><div>成交率 (%)</div><p class="col_45B9BC">{{monthList.turnover_rate?monthList.turnover_rate:0}}</p></li>
          </ul>
        </div>
        <table class="performance__table" cellspacing="0">
          <tr><th>日期</th><th>销售额(元)</th><th>订单量(个)</th><th>成交率(%)</th></tr>
          <tr v-for="(proItem,proIndex) in monthList.list" :key="proIndex">
            <td>{{proItem.day}}</td><td>{{proItem.sale_price_total?proItem.sale_price_total:0}}</td><td>{{proItem.sale_total}}</td><td>{{proItem.turnover_rate}}</td>
          </tr>
        </table>
      </van-tab>
      <van-tab title="当年">
        <div class="endTime">数据截止时间：{{time}}</div>
        <div class="performance__total">
          <ul>
            <li><div>销售额 (元)</div><p class="col_45B9BC">{{yearList.sale_price_total?yearList.sale_price_total:0}}</p></li>
            <li><div>订单量 (个)</div><p class="col_45B9BC">{{yearList.sale_total?yearList.sale_total:0}}</p></li>
            <li><div>成交率 (%)</div><p class="col_45B9BC">{{yearList.turnover_rate?yearList.turnover_rate:0}}</p></li>
          </ul>
        </div>
        <table class="performance__table" cellspacing="0">
          <tr><th>月份</th><th>销售额(元)</th><th>订单量(个)</th><th>成交率(%)</th></tr>
          <tr v-for="(proItem,proIndex) in yearList.list" :key="proIndex">
            <td>{{proItem.month}}</td><td>{{proItem.sale_price_total?proItem.sale_price_total:0}}</td><td>{{proItem.sale_total}}</td><td>{{proItem.turnover_rate}}</td>
          </tr>
        </table>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  export default {
    name: "performanceCheck",
    data(){
      return{
        active:0,
        store_id:0,
        time:'',
        dayList:{
          // allPrice:'2000.00',
          // allNum:'100',
          // allRate:'98%',
          // itemList:[
          //   {itemType:'0',itemName:'全身理疗 ×1',itemPrice:'¥269.00',itemState:'成交'},
          //   {itemType:'0',itemName:'全身理疗 ×1',itemPrice:'¥269.00',itemState:'成交'},
          //   {itemType:'1',itemName:'全身理疗 ×1',itemPrice:'¥269.00',itemState:'未成交'},
          //   {itemType:'0',itemName:'全身理疗 ×1',itemPrice:'¥269.00',itemState:'成交'},
          //   {itemType:'0',itemName:'全身理疗 ×1',itemPrice:'¥269.00',itemState:'成交'},
          //   {itemType:'0',itemName:'全身理疗 ×1',itemPrice:'¥269.00',itemState:'成交'},
          //   {itemType:'0',itemName:'全身理疗 ×1',itemPrice:'¥269.00',itemState:'成交'},
          //   {itemType:'0',itemName:'全身理疗 ×1',itemPrice:'¥269.00',itemState:'成交'},
          //   {itemType:'0',itemName:'全身理疗 ×1',itemPrice:'¥269.00',itemState:'成交'},
          // ]
        },
        monthList:{
          // allPrice:'32000.00',
          // allNum:'2000',
          // allRate:'98%',
          // itemList:[
          //   {date:'09-01',itemPrice:'2000.00',itemNum:'10',itemRate:'98%'},
          //   {date:'09-02',itemPrice:'2000.00',itemNum:'15',itemRate:'95%'},
          //   {date:'09-02',itemPrice:'2000.00',itemNum:'15',itemRate:'90%'},
          //   {date:'09-02',itemPrice:'2000.00',itemNum:'20',itemRate:'99%'},
          // ]
        },
        yearList:{
          // allPrice:'999000.00',
          // allNum:'30000',
          // allRate:'95%',
          // itemList:[
          //   {date:'01月',itemPrice:'31000.00',itemNum:'500',itemRate:'98%'},
          //   {date:'02月',itemPrice:'20000.00',itemNum:'366',itemRate:'95%'},
          //   {date:'03月',itemPrice:'50000.00',itemNum:'450',itemRate:'90%'},
          //   {date:'04月',itemPrice:'40000.00',itemNum:'666',itemRate:'99%'},
          // ]
        },
       
      }      
     
    },
     created() {
          this.store_id = this.$route.query.store_id;
          this.get_achievement();
        },
        methods: {
          get_achievement(){
            this.axios({
              url: this.api.store.store_achievement,
              data: {
                store_id:this.store_id
              }
            }).then(res => {
              if (res.error === 0) {
                this.dayList = res.date.day;         
                this.monthList = res.date.month
                this.yearList = res.date.years
                this.time = res.time
              }
            });
          }
        },
  }
</script>

<style scoped>
  .endTime{
    padding: 0 .75rem .65rem;
    color: #999;
    font-size: .6rem;
  }
  .performance__total{
    padding: .25rem .75rem;
  }
  .performance__total ul{
    background: #fff;
    display: flex;
    font-size: .65rem;
    color: #666;
  }
  .performance__total ul li{
    width: 100%;
    text-align: center;
    margin: .9rem 0;
    padding: 0 .25rem;
    border-right: 1px solid rgba(231,231,231,.5);
  }
  .performance__total ul li:last-child{
    border: 0;
  }
  .performance__total ul li>p{
    font-size: .85rem;
    padding-top: .4rem;
    line-height: .85rem;
    font-weight: 500;
  }
  .performance__table{
    padding: .5rem;
    font-size: .75rem;
    color: #666;
    width: 100%;
    text-align: center;
  }
  .performance__table th{
    background: #D2E6E7;
    font-size: .7rem;
    color: #333;
    font-weight: 400;
    padding: .6rem .25rem;
  }
  .performance__table td{
    background: #fff;
    font-size: .7rem;
    padding: .6rem .35rem;
    border-bottom: 1px solid rgba(231,231,231,.5);
  }

</style>



// WEBPACK FOOTER //
// src/views/store/performanceCheck.vue